/* BOKAAH HOME — theme behaviours */
(function () {
  'use strict';

  var doc = document;

  /* ---------- generic drawers (menu + filters) ---------- */
  function openDrawer(el) {
    if (!el) return;
    el.setAttribute('data-open', '');
    var ov = doc.querySelector('[data-bk-overlay]');
    if (ov) ov.setAttribute('data-open', '');
    doc.body.style.overflow = 'hidden';
    var focusable = el.querySelector('button, a, input');
    if (focusable) focusable.focus({ preventScroll: true });
  }
  function closeDrawers() {
    doc.querySelectorAll('[data-bk-drawer]').forEach(function (d) { d.removeAttribute('data-open'); });
    var ov = doc.querySelector('[data-bk-overlay]');
    if (ov) ov.removeAttribute('data-open');
    doc.body.style.overflow = '';
  }

  doc.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-bk-drawer-open]');
    if (openBtn) {
      e.preventDefault();
      openDrawer(doc.querySelector(openBtn.getAttribute('data-bk-drawer-open')));
      return;
    }
    if (e.target.closest('[data-bk-drawer-close]') || e.target.closest('[data-bk-overlay]')) {
      e.preventDefault();
      closeDrawers();
    }
  });
  doc.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawers(); });

  var prefersStill = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- product gallery (slider variant) ---------- */
  function initGallery(root) {
    if (root.dataset.bkReady) return;
    var slides = root.querySelectorAll('[data-bk-slide]');
    var thumbs = root.querySelectorAll('[data-bk-thumb]');
    if (slides.length < 1) return;
    root.dataset.bkReady = '1';

    var index = 0;
    var delay = parseInt(root.getAttribute('data-bk-autoplay'), 10) || 0;
    var timer = null;
    var idle = null;
    var visible = true;

    function show(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) {
        if (n === index) { s.setAttribute('data-active', ''); } else { s.removeAttribute('data-active'); }
      });
      thumbs.forEach(function (t, n) {
        if (n === index) { t.setAttribute('data-active', ''); t.setAttribute('aria-current', 'true'); }
        else { t.removeAttribute('data-active'); t.removeAttribute('aria-current'); }
      });
    }

    function stop() { if (timer) { window.clearInterval(timer); timer = null; } }
    function start() {
      if (!delay || slides.length < 2) return;
      stop();
      timer = window.setInterval(function () {
        if (doc.hidden || !visible) return;
        show(index + 1);
      }, delay);
    }
    function bump() {
      stop();
      window.clearTimeout(idle);
      idle = window.setTimeout(start, delay + 3000);
    }

    thumbs.forEach(function (t, n) {
      t.addEventListener('click', function () { show(n); bump(); });
    });
    var prev = root.querySelector('[data-bk-prev]');
    var next = root.querySelector('[data-bk-next]');
    if (prev) prev.addEventListener('click', function () { show(index - 1); bump(); });
    if (next) next.addEventListener('click', function () { show(index + 1); bump(); });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
      }, { threshold: 0.2 }).observe(root);
    }
    doc.addEventListener('visibilitychange', function () { if (doc.hidden) { stop(); } else { start(); } });

    show(0);
    start();
    root.bkShow = function (i) { show(i); bump(); };
  }

  /* ---------- product gallery (mobile: swipe + autoplay) ----------
     The track uses scroll-snap: x mandatory, and Safari lets that snapping
     cancel a programmatic scrollTo. So the slide is animated by hand with
     snapping switched off for the duration, then handed back to the browser. */
  function initMobileGallery(root) {
    if (root.dataset.bkReady) return;
    var scroller = root.querySelector('[data-bk-gscroll]');
    if (!scroller) return;
    root.dataset.bkReady = '1';

    var out = root.querySelector('[data-bk-gcount]');
    var total = scroller.children.length;
    var index = 0;
    var delay = parseInt(root.getAttribute('data-bk-autoplay'), 10) || 0;
    var timer = null;
    var idle = null;
    var visible = true;
    var animating = false;

    function paint() {
      if (out) out.textContent = Math.min(Math.max(index + 1, 1), total) + ' / ' + total;
    }
    function readIndex() {
      var w = scroller.clientWidth || 1;
      index = Math.round(scroller.scrollLeft / w);
      paint();
    }
    scroller.addEventListener('scroll', function () {
      if (animating) return;
      window.clearTimeout(scroller._t);
      scroller._t = window.setTimeout(readIndex, 60);
    });

    function glide(to, dur, done) {
      var from = scroller.scrollLeft;
      var diff = to - from;
      if (Math.abs(diff) < 1) { scroller.scrollLeft = to; if (done) done(); return; }
      animating = true;
      scroller.style.scrollSnapType = 'none';
      var t0 = null;
      function step(ts) {
        if (t0 === null) t0 = ts;
        var p = Math.min((ts - t0) / dur, 1);
        var e = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
        scroller.scrollLeft = from + diff * e;
        if (p < 1 && animating) {
          window.requestAnimationFrame(step);
        } else {
          animating = false;
          scroller.style.scrollSnapType = '';
          if (done) done();
        }
      }
      window.requestAnimationFrame(step);
    }

    function advance() {
      if (doc.hidden || !visible || animating) return;
      var w = scroller.clientWidth || 1;
      if (w < 2 || !scroller.offsetParent) return;
      var next = index + 1;
      var wrap = next >= total;
      if (wrap) next = 0;
      index = next;
      paint();
      if (wrap || prefersStill) {
        scroller.style.scrollSnapType = 'none';
        scroller.scrollLeft = next * w;
        scroller.style.scrollSnapType = '';
      } else {
        glide(next * w, 650);
      }
    }
    function stop() { if (timer) { window.clearInterval(timer); timer = null; } }
    function start() {
      if (!delay || total < 2) return;
      stop();
      timer = window.setInterval(advance, delay);
    }
    /* the moment a finger touches it, autoplay backs off */
    function bump() {
      animating = false;
      stop();
      window.clearTimeout(idle);
      idle = window.setTimeout(start, delay + 3000);
    }
    ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) {
      scroller.addEventListener(ev, bump, { passive: true });
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
      }, { threshold: 0.15 }).observe(root);
    }
    doc.addEventListener('visibilitychange', function () { if (doc.hidden) { stop(); } else { start(); } });

    readIndex();
    start();
  }

  /* ---------- variant change → jump gallery to that media ---------- */
  doc.addEventListener('change', function (e) {
    if (!e.target.matches('variant-selects input, variant-selects select')) return;
    window.setTimeout(function () {
      var input = doc.querySelector('[data-bk-pdp] .product-variant-id');
      if (!input) return;
      var pos = doc.querySelector('[data-bk-variant-media="' + input.value + '"]');
      if (!pos) return;
      var i = parseInt(pos.getAttribute('data-bk-index'), 10) || 0;
      var g = doc.querySelector('[data-bk-gallery]');
      if (g && g.bkShow) g.bkShow(i);
      var m = doc.querySelector('[data-bk-gallery-mob] [data-bk-gscroll]');
      if (m && m.offsetParent) {
        m.style.scrollSnapType = 'none';
        m.scrollLeft = i * (m.clientWidth || 1);
        m.style.scrollSnapType = '';
      }
    }, 350);
  });

  /* ---------- wishlist (localStorage) ---------- */
  var WKEY = 'bokaah:wishlist';
  function readWish() {
    try { return JSON.parse(localStorage.getItem(WKEY) || '[]'); } catch (err) { return []; }
  }
  function writeWish(list) {
    try { localStorage.setItem(WKEY, JSON.stringify(list)); } catch (err) { /* private mode */ }
  }
  function paintWish() {
    var list = readWish();
    doc.querySelectorAll('[data-bk-wish]').forEach(function (b) {
      var on = list.indexOf(b.getAttribute('data-bk-wish')) > -1;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.textContent = on ? '♥' : '♡';
    });
    doc.querySelectorAll('[data-bk-wish-count]').forEach(function (n) {
      n.textContent = list.length ? '♡ (' + list.length + ')' : '♡';
    });
  }
  doc.addEventListener('click', function (e) {
    var b = e.target.closest('[data-bk-wish]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var id = b.getAttribute('data-bk-wish');
    var list = readWish();
    var i = list.indexOf(id);
    if (i > -1) { list.splice(i, 1); } else { list.push(id); }
    writeWish(list);
    paintWish();
  });

  /* ---------- collection: auto-submit filter form ---------- */
  function initFilterForm(form) {
    if (form.dataset.bkReady) return;
    form.dataset.bkReady = '1';
    form.querySelectorAll('input[type=checkbox], input[type=radio]').forEach(function (input) {
      input.addEventListener('change', function () { form.submit(); });
    });
  }

  /* ---------- quantity stepper ---------- */
  doc.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bk-qty]');
    if (!btn) return;
    e.preventDefault();
    var input = btn.parentNode.querySelector('input');
    if (!input) return;
    var step = btn.getAttribute('data-bk-qty') === 'up' ? 1 : -1;
    var min = parseInt(input.getAttribute('min'), 10) || 1;
    input.value = Math.max(min, (parseInt(input.value, 10) || min) + step);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  function initAll() {
    doc.querySelectorAll('[data-bk-gallery]').forEach(initGallery);
    doc.querySelectorAll('[data-bk-gallery-mob]').forEach(initMobileGallery);
    doc.querySelectorAll('[data-bk-filter-form]').forEach(initFilterForm);
    paintWish();
  }

  if (doc.readyState === 'loading') {
    doc.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  doc.addEventListener('shopify:section:load', initAll);
  doc.addEventListener('shopify:section:select', initAll);
})();
